import { useConfigList } from "./useConfigList";
import { useState, useEffect } from "react";

export function useGovernance(listType) {
  return useConfigList(listType);
}

const API = process.env.REACT_APP_BACKEND_URL;
const statutsCache = {};

export function useStatutsConfig() {
  const tenantSlug = localStorage.getItem("current_tenant_slug") || "tef";
  const cacheKey = `statuts__${tenantSlug}`;

  const [config, setConfig] = useState(statutsCache[cacheKey] || null);
  const [loading, setLoading] = useState(!statutsCache[cacheKey]);

  useEffect(() => {
    const slug = localStorage.getItem("current_tenant_slug") || "tef";
    const key = `statuts__${slug}`;
    if (statutsCache[key]) { setConfig(statutsCache[key]); setLoading(false); return; }
    let cancelled = false;
    const load = async () => {
      try {
        const token = localStorage.getItem("session_token");
        const res = await fetch(`${API}/api/metier/statuts-config/frontend-config`, {
          headers: { ...(token && { Authorization: `Bearer ${token}` }) },
          credentials: "include"
        });
        if (res.ok && !cancelled) {
          const data = await res.json();
          const cfg = {
            statuts: data.statuts || {},
            phase_statuts: data.phase_statuts || {},
            phase_labels: data.phase_labels || {}
          };
          statutsCache[key] = cfg;
          setConfig(cfg);
        }
      } catch (e) {
        console.error("useStatutsConfig:", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  return { config, loading };
}
